<template>
  <div>
    <!-- 老模型赛事球员卡过渡页面 -->
  </div>
</template>

<script>
import { getPlayerCardReseller } from '@/api/match'
import Vue from 'vue'
import { Toast } from 'vant';
Vue.use(Toast);
export default {
  data() {
    return {
      objId: '',
    };
  },
  mounted() {
    this.objId = this.$route.query.objId
    Toast.loading({
      message: '加载中...',
      forbidClick: true,
      overlay: true,
      duration: 0
    });
    this.getPlayerCardReseller()
  },
  methods: {
    getPlayerCardReseller() {
      getPlayerCardReseller({ objId: this.objId, objType: 'match' }).then(res => {
        Toast.clear();
        if (res.data.detail.id) {
          let url = location.origin + location.pathname + `#/match-manage/player-card-order-list/${this.objId}?resellerId=${res.data.detail.id}&objType=match`
          window.location.replace(url);
        } else {
          let url = location.origin + location.pathname + `#/match-manage/set-player-card/${this.objId}?objType=match`
          window.location.replace(url);
        }
      })
    }
  },
};
</script>

<style scoped lang="scss"></style>
